import { render, staticRenderFns } from "./FilesTable.vue?vue&type=template&id=777f8364"
import script from "./FilesTable.vue?vue&type=script&lang=js"
export * from "./FilesTable.vue?vue&type=script&lang=js"
import style0 from "./FilesTable.vue?vue&type=style&index=0&id=777f8364&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/latinad/panel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('777f8364')) {
      api.createRecord('777f8364', component.options)
    } else {
      api.reload('777f8364', component.options)
    }
    module.hot.accept("./FilesTable.vue?vue&type=template&id=777f8364", function () {
      api.rerender('777f8364', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/popups/show-docs-popup/FilesTable.vue"
export default component.exports